<template>

  <div class="">
    <div v-if="task_mode">

      <div v-if="selected_task" @mouseover="show=true" @mouseleave="show=false">
        <code>
        <span  :class="[(duration_actual ? selected_task.duration_actual : selected_task.duration) / 60 >= 1 ? (duration_actual ? 'text-primary font-weight-bold' : 'text-blue font-weight-bold') : 'text-secondary']">
          <button v-on:click="addDuration(-60)" class="btn btn-sm btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">-</button>
          <span class="">{{Math.floor((duration_actual ? selected_task.duration_actual : selected_task.duration) / 60)}}{{ $t('elements.duration_picker.hour_letter') }}</span>
          <button v-on:click="addDuration(60)" class="btn btn-sm btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">+</button>
        </span>

        <span  :class="[(duration_actual ? selected_task.duration_actual : selected_task.duration) % 60 !== 0 ? (duration_actual ? 'text-primary font-weight-bold' : 'text-blue font-weight-bold') : 'text-secondary']">
          <button v-on:click="addDuration(-10)" class="btn btn-sm  btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">-</button>
          <span >{{(duration_actual ? selected_task.duration_actual : selected_task.duration) % 60 || ' 0'}}{{ $t('elements.duration_picker.minute_letter') }}</span>
          <button v-on:click="addDuration(10)" class="btn btn-sm btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">+</button>
        </span>
        </code>
      </div>
    </div>
    <div v-else-if="is_for_project">
      <code>
        <span  :class="[projectTime / 60 >= 1 ? 'text-blue font-weight-bold' : 'text-secondary']">
          <button v-on:click="addDuration(-60)" class="btn btn-sm btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">-</button>
          <span class="">{{Math.floor((projectTime) / 60)}}{{ $t('elements.duration_picker.hour_letter') }}</span>
          <button v-on:click="addDuration(60)" class="btn btn-sm btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">+</button>
        </span>

        <span  :class="[projectTime % 60 !== 0 ? 'text-blue font-weight-bold' : 'text-secondary']">
          <button v-on:click="addDuration(-10)" class="btn btn-sm  btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">-</button>
          <span >{{projectTime % 60 || ' 0'}}{{ $t('elements.duration_picker.minute_letter') }}</span>
          <button v-on:click="addDuration(10)" class="btn btn-sm btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">+</button>
        </span>
      </code>
    </div>
    <div v-else>
      <div @mouseover="show=true" @mouseleave="show=false">
        <code>
        <span  :class="[(duration_actual ? selected_duration_actual : selected_duration) / 60 >= 1 ? (duration_actual ? 'text-primary font-weight-bold' : 'text-blue font-weight-bold') : 'text-secondary']">
          <button v-on:click="addDuration(-60)" class="btn btn-sm btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">-</button>
          <span class="">{{Math.floor((duration_actual ? selected_duration_actual : selected_duration) / 60)}}{{ $t('elements.duration_picker.hour_letter') }}</span>
          <button v-on:click="addDuration(60)" class="btn btn-sm btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">+</button>
        </span>

          <span  :class="[(duration_actual ? selected_duration_actual : selected_duration) % 60 !== 0 ? (duration_actual ? 'text-primary font-weight-bold' : 'text-blue font-weight-bold') : 'text-secondary']">
          <button v-on:click="addDuration(-10)" class="btn btn-sm  btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">-</button>
          <span >{{(duration_actual ? selected_duration_actual : selected_duration) % 60 || ' 0'}}{{ $t('elements.duration_picker.minute_letter') }}</span>
          <button v-on:click="addDuration(10)" class="btn btn-sm btn-light ml-2 mr-2" :class="[show ? 'show' : 'hide']">+</button>
        </span>
        </code>
      </div>
    </div>



  </div>

</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: "DurationPicker",
        computed: {
            ...mapGetters([
                'selected_task',
                'selected_duration',
                'selected_duration_actual',
                'account',
            ]),
          projectTime: function () {
              return this.project.default_duration ? this.project.default_duration : 0;
          }
        },
        props: {
            duration_actual: {
                default: false
            },
            task_mode: {
                default: true,
            },
            is_for_project: {
                default: true
            },
            project: {
              default: function () {
                return {}
              }
            }

        },
        data() {
            return {
                show: false,
            }
        },
        watch: {
            selected_task: function () {
                if (this.task_mode) {
                    this.task = this.selected_task;
                }

            }
        },
        methods: {
            addDuration(delta_value) {
                if (this.task_mode) {
                    if (this.duration_actual) {
                        if (this.selected_task.duration_actual + parseFloat(delta_value) < 0) {
                            return
                        }
                        this.selected_task.duration_actual += parseFloat(delta_value);
                        this.selected_task.duration_emika = false;
                    } else {
                        if (this.selected_task.duration + parseFloat(delta_value) < 0) {
                            return
                        }
                        this.selected_task.duration += parseFloat(delta_value);
                        this.selected_task.duration_emika = false;
                    }
                } else if (this.is_for_project) {
                    let new_value = this.projectTime + parseFloat(delta_value);
                    return (new_value < 0) ? true : this.$emit('selectDuration', new_value);
                    // if (new_value < 0) {
                    //   return
                    // }
                    // this.$emit('selectDuration', new_value);
                } else {
                    let new_value = this.selected_duration + parseFloat(delta_value);
                    if (new_value < 0) {
                        return
                    }
                    this.$store.commit('setSelectedDuration', new_value);
                }

            },
        },
        created() {

        }
    }
</script>

<style scoped>

  .text-blue {
    color: #2c7be5;
  }

  .show {
    opacity: 1;
    -webkit-transition: opacity 0.3s ease-in-out;
    -moz-transition: opacity 0.3s ease-in-out;
    -ms-transition: opacity 0.3s ease-in-out;
    -o-transition: opacity 0.3s ease-in-out;
    transition: opacity 0.3s ease-in-out;
  }

  .hide {
    opacity: 0.2;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -ms-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }

</style>
